/**
 * Locations API Endpoints
 */
export const LOCATIONS_ENDPOINTS = {
  /**
   * Get all locations (paginated).
   * @method GET
   * @endpoint /locations
   */
  LOCATIONS: "/locations",

  /**
   * Get a single location by ID (includes instruments[]).
   * @method GET
   * @endpoint /locations/{id}
   */
  LOCATION_BY_ID: (id: number) => `/locations/${id}`,

  /**
   * Create a new location.
   * @method POST
   * @endpoint /locations
   */
  CREATE_LOCATION: "/locations",

  /**
   * Update an existing location.
   * @method PUT
   * @endpoint /locations/{id}
   */
  UPDATE_LOCATION: (id: number) => `/locations/${id}`,

  /**
   * Delete a location.
   * @method DELETE
   * @endpoint /locations/{id}
   */
  DELETE_LOCATION: (id: number) => `/locations/${id}`,
} as const;
